// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__HnmMC","icon2x":"styles_icon2x__fLmYF"};